module.exports = __webpack_public_path__ + "img/1F1E7-1F1ED.6d0badf7.svg";